export enum ExperienceValueMapping {
  NONE = 1,
  LIMITED = 3,
  EXPERIENCED = 5,
}

export enum ExitTimingMapping {
  ONE_TO_TWO_YEARS = 1,
  THREE_TO_FOUR_YEARS = 3,
  FIVE_TO_TEN_YEARS = 5,
  OVER_10_YEARS = 10,
}

// see src/concreitweb/dateutil.py class Frequency
/* eslint-disable sort-keys */
export enum FrequencyMap {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  BI_MONTHLY = 'BI_MONTHLY', // client-side only
  ONE = 'ONE', // client-side only
}

export enum RiskValueMapping {
  LOW = 1,
  MEDIUM = 3,
  HIGH = 5,
}

// see src/concreitweb/dateutil.py class Weekday
/* eslint-disable sort-keys */
export enum WeekdayMap {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}
